import React from 'react';

import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon';

export const Receipt = Styled(
	createSvgIcon(
		<svg
			width='48'
			height='48'
			viewBox='0 0 48 48'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M44 12V16.84C44 20 42 22 38.84 22H32V8.02C32 5.8 33.82 4 36.04 4C38.22 4.02 40.22 4.9 41.66 6.34C43.1 7.8 44 9.8 44 12Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeMiterlimit='10'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M4 14V42C4 43.66 5.87995 44.6 7.19995 43.6L10.62 41.04C11.42 40.44 12.54 40.52 13.26 41.24L16.58 44.58C17.36 45.36 18.64 45.36 19.42 44.58L22.78 41.22C23.48 40.52 24.6 40.44 25.38 41.04L28.8 43.6C30.12 44.58 32 43.64 32 42V8C32 5.8 33.8 4 36 4H14H12C6 4 4 7.58 4 12V14Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeMiterlimit='10'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M12 18H24'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M13.5 26H22.5'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>,
		'Receipt'
	)
);

export default Receipt;
